<template>
  <Appendix
    title="Phụ lục ủy quyền ngân hàng"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
    :_showDetails="false"
  >
    <template #file="item">
      <div class="form-detail">
        <UploadMultiple
          :lsData="lsData(item)"
          :canUpload="false"
          :title="`File phụ lục ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
  </Appendix>
</template>
<script>
  import Appendix from './Appendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { computed } from '@vue/composition-api'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, UploadMultiple },
    data() {
      return {}
    },
    methods: {
      lsData(item) {
        return [...(item.appendixAuthBank.pdfs ?? []), ...(item.appendixAuthBank.images ?? [])]
      },
    },
  }
</script>

<style scoped></style>
